import { render, staticRenderFns } from "./orgNotificationEmails.vue?vue&type=template&id=742fb751&scoped=true&"
import script from "./orgNotificationEmails.vue?vue&type=script&lang=js&"
export * from "./orgNotificationEmails.vue?vue&type=script&lang=js&"
import style0 from "./orgNotificationEmails.vue?vue&type=style&index=0&id=742fb751&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742fb751",
  null
  
)

export default component.exports